import { FunctionComponent } from 'react';

interface DashboardProps {}

export const Dashboard: FunctionComponent<DashboardProps> = () => (
  <div>Out-patient</div>
);
